var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-activity h-[10px]",class:['loader-bar-'+_vm.mode,],attrs:{"height":_vm.height?_vm.height:'3px'}},[_c('div',{staticClass:"indeterminate"})])
}
var staticRenderFns = []

export { render, staticRenderFns }